module.exports = __webpack_public_path__ + "static/media/coyotes-map.a7243443.png";